module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABABAMAAABYR2ztAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAVUExURUdwTDJv/zhw/zNv/zJu/zBw/zNv/ysnjyQAAAAGdFJOUwDgILJuEMZTE0MAAACGSURBVEjHY2AYBUMKsBgKYgJTJAVuaVhAMpICM2wK0hRIUIDVikRkR2JTYITsjSAlTDBCY9QRS4SKEArMNAeEAkasCgQIKUhAKGDGqsAAoYAVW5pIDkByJSuWCA0YaXkTS0wKOhDKmylICtII5SwxrCoI5W7k7B+MTYEpgbypOlrwjgJsAACkho4JGrGqigAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu.png
// module id = +HEJ
// module chunks = 1